


























































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Feed from "@/components/timeline/_feed.vue";
import {AxiosError, AxiosResponse} from "axios";
import {scrollDone} from "@/script/scrollManager";
import {mapGetters} from "vuex";
import {User} from "@/types";
import Post from "@/components/timeline/_post.vue";
import UserAvatar from "@/components/user/_userAvatar.vue";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import TiptapSns from "@/components/timeline/_tiptapSns.vue";
import TiptapPost from "@/components/timeline/_tiptapBlog.vue";
import ImageUploaderBtn from "@/components/timeline/post/_imageUploaderBtn.vue";
import Toast from "@/script/message";
import SubscribeBtn from "@/components/community/_subscribeBtn.vue";
import _ from "lodash";
import MetaSetting from "@/script/metaSetting";

@Component({
    computed: {
        ...mapGetters(["user"]),
        //timeline 중복 제거
        filterDupTl: function () {
            return _.uniqBy(this['timeline'], (e: any) => {
                    return e.id;
                }
            )
        }
    },
    components: {
        Feed,
        PulseLoader,
        Post,
        UserAvatar,
        Swiper,
        SwiperSlide,
        TiptapSns,
        TiptapPost,
        ImageUploaderBtn,
        SubscribeBtn
    },
})
export default class Timeline extends Vue {
    @Prop() currPage!: string;
    @Prop() id!: any;
    @Prop() community!: any;
    @Prop() game!: any;
    @Prop() mediaType!: any;

    toast = new Toast();
    metaSetting !: MetaSetting;

    timeline: any = [];
    user!: User;

    //parameters
    limit: number = 10;
    offset: number = 0;
    sort: string = '';
    media: string = '';

    //state
    isAddData: boolean = false;
    hasData: boolean = true;

    activeTab: string = "SNS";

    feedId = '';
    pickedReason: any = '';
    originImg = '';

    commentId = '';
    postId = '';

    isFirstLoading: boolean = true;


    mounted() {
        this.$store.dispatch("loginState")
            .then(() => {
                this.fetch()
                this.createMetaSetting();
            });

        window.addEventListener("scroll", this.scrollCheck);
    }

    beforeDestroy() {
        window.removeEventListener("scroll", this.scrollCheck);
    }

    createMetaSetting() {
        switch (this.currPage) {
            case 'user':

                break;
            case 'game':
                break;
            case 'community':
                this.metaSetting = new MetaSetting({
                    title: `${this.community.name} | Zempie.com`,
                    meta: [
                        {name: 'description', content: this.community.description},
                        {
                            property: 'og:url',
                            content: `${this.$store.getters.homeUrl}/${this.$i18n.locale}/community/${this.community.id}/timeline`
                        },
                        {property: 'og:title', content: `${this.community.name} | Zempie.com`},
                        {property: 'og:description', content: this.community.description},
                    ]
                });
                break;
            case 'channel':
                break;
        }


    }

    reFetch() {
        this.$emit('reFetch')
        this.initData()
        this.fetch()
    }

    deleteComment() {
        this.$api.deleteComment(this.postId, this.commentId)
            .then((res) => {
                this.reFetch()
            })
            .catch((err) => {

            })
            .finally(() => {
                this.$modal.hide('deleteComment')
            })
    }

    beforeOpen(event) {
        this.commentId = event.params.commentId;
        this.postId = event.params.postId;

    }

    initData() {
        this.isAddData = false
        this.hasData = false
        this.limit = 10;
        this.offset = 0;
        this.timeline = [];
        this.sort = '';
        this.media = '';
        window.scrollTo(0, 0)
    }


    fetch() {
        switch (this.currPage) {
            case 'user':
                const userObj = {
                    limit: this.limit,
                    offset: this.offset,
                    sort: this.sort,
                    media: this.$route.query.media || this.mediaType
                }

                const channel_id: any = this.$route.name === 'MyChannel' ? this.user.channel_id : this.$route.params.channel_id;

                this.$api.userTimeline(channel_id, userObj)
                    .then((res: any) => {
                        if (this.isAddData) {
                            if (res.result.length > 0) {
                                this.timeline = [...this.timeline, ...res.result]
                            }
                            else {
                                window.removeEventListener("scroll", this.scrollCheck);
                            }
                        }
                        else {
                            this.timeline = res.result;
                            this.isAddData = true
                        }
                    })
                    .catch((err: AxiosError) => {
                        this.$router.push(`/${this.$i18n.locale}/communityList`)

                    })
                    .finally(() => {
                        this.isFirstLoading = false;
                        this.timeline = _.orderBy(this.timeline, 'createdAt', 'desc')
                    })

                break;
            case 'game':
                const gameObj = {
                    game_id: this.game.id,
                    limit: this.limit,
                    offset: this.offset,
                    sort: this.sort,
                    media: this.$route.query.media
                }
                this.$api.gameTimeline(gameObj)
                    .then((res: any) => {
                        if (this.isAddData, res) {
                            if (res.result.length > 0) {
                                this.timeline = [...this.timeline, ...res.result]
                            }
                            else {
                                this.hasData = false
                                window.removeEventListener("scroll", this.scrollCheck);
                            }
                        }
                        else {
                            this.timeline = res.result;
                            this.isAddData = true
                        }
                    })
                    .catch((err: AxiosError) => {

                    })
                    .finally(() => {
                        this.isFirstLoading = false;
                        this.timeline = _.orderBy(this.timeline, 'createdAt', 'desc')
                    })
                break;
            case 'community':
                const comObj = {
                    community_id: this.$route.params.community_id,
                    limit: this.limit,
                    offset: this.offset,
                    sort: this.sort,
                    media: this.$route.query.media
                }
                this.$api.communityTimeline(comObj)
                    .then((res: any) => {

                        if (this.isAddData) {
                            if (res.result.length > 0) {
                                this.timeline = [...this.timeline, ...res.result]
                            }
                            else {
                                this.hasData = false
                                window.removeEventListener("scroll", this.scrollCheck);

                            }
                        }
                        else {

                            this.timeline = res.result;
                            this.isAddData = true
                        }


                    })
                    .catch((err: AxiosError) => {


                    })
                    .finally(() => {
                        this.isFirstLoading = false;
                        this.timeline = _.orderBy(this.timeline, 'createdAt', 'desc')
                    })

                break;
            //커뮤니티 내의 채널
            case 'channel':

                const chaObj = {
                    limit: this.limit,
                    offset: this.offset,
                    sort: this.sort,
                    media: this.media
                }

                this.$api.channelTimeline(this.$store.getters.currPage.community[0].id, this.$store.getters.currPage.community[0].channel_id, chaObj)
                    .then((res: any) => {
                        if (this.isAddData) {
                            if (res.result.length > 0) {
                                this.timeline = [...this.timeline, ...res.result]
                            }
                            else {
                                // console.log('no data')
                                this.hasData = false

                            }
                        }
                        else {

                            this.timeline = res.result;
                            this.isAddData = true
                        }


                    })
                    .catch((err: AxiosError) => {


                    })
                    .finally(() => {
                        this.isFirstLoading = false;
                        this.timeline = _.orderBy(this.timeline, 'createdAt', 'desc')
                    })

                break;
        }

    }


    ableToPost() {
        let result: any = false;
        //커뮤니티 블락당한 경우
        if (this.user) {
            switch (this.currPage) {
                case 'user':
                    if (this.user.uid === this.$route.params.channel_id || this.$route.name === 'MyChannel') {
                        result = true;
                    }
                    else {
                        result = false;
                    }
                    break;
                case 'community' :
                    if (this.community.user_block) {
                        result = 'block'
                    }
                    else {
                        result = true;
                    }
                    break;
                case 'channel' :
                    result = true;
                    break;
                case 'game' :
                    if ((this.game.user && this.game.user.uid) === this.user.uid) {
                        result = true;
                    }

                    break;
            }
        }
        return result;

    }

    openEdit() {
        this.$store.dispatch('resetAttFiles')
        if (this.user) {
            this.$modal.show('writingModal')
        }
        else {
            this.$modal.show('needLogin')
            this.$store.commit('needLogin', true)
        }
    }

    openPostModal() {
        if (!this.user) {
            this.$modal.show('needLogin')
            this.$store.commit('needLogin', true)
        }
        else if (this.user) {
            switch (this.currPage) {
                case 'user' :
                    this.$modal.show('modalPost')
                    break;
                case 'community' :
                    if (!this.community.is_subscribed) {
                        this.$modal.show('needSubscribe')
                    }
                    else {
                        this.$modal.show('modalPost')
                    }
                    break;
                case 'game' :
                    // if(this.game.user.uid === this.user.uid){
                    this.$modal.show('modalPost')
                    // }
                    break;
            }
        }

    }

    needSubscribe() {
        this.$api.subscribe({user_id: this.user.id, community_id: this.community.id})
            .then((res: AxiosResponse) => {
                this.$emit('reFetch')
            }).catch((err: AxiosError) => {
            if (err.message) {
                alert(err.message)
            }
        })
    }

    closePostModal() {
        this.fetch();
        this.isAddData = false;
        // (this.$refs.editModal as any).hide();
    }

    scrollCheck() {
        if (scrollDone(document.documentElement)) {
            this.offset += this.limit;
            this.fetch();
        }
    }

    closeModal() {
        this.$modal.hide('deleteModal')
        this.$store.commit('postContents', '')
        this.$store.dispatch('resetAttFiles')
        this.$store.dispatch('resetBlogImgArr')
    }

    @Watch('$route.query')
    watchMedia() {
        this.initData()
        this.media = (this.$route.query.media as string);
        this.fetch();
        this.createMetaSetting();
    }

    deleteFeed(feedId: any) {
        this.feedId = feedId;
        this.$modal.show('deleteModal')
    }

    reportPost(feedId: any) {
        this.feedId = feedId;
    }

    yesDeletePost() {
        this.$modal.hide('deleteModal')


        this.$api.deletePost(this.feedId)
            .then((res: any) => {
                if (res.success) {
                    this.$toasted.clear();
                    this.toast.successToast(`${this.$t('posting.deleted')}`)
                }
                this.timeline = []
                this.initData();
                this.fetch();
            })
            .catch((err: any) => {

            })

    }

    sendReport() {
        const obj = {
            post_id: this.feedId,
            user_id: this.user.id,
            targetType: 'POST',
            report_reason: this.pickedReason
        }
        this.$api.reportPost(obj)
            .then((res: AxiosResponse) => {

            })
            .catch((err: AxiosError) => {

                this.toast.failToast(err.message)
            })
            .finally(() => {
                this.$modal.hide('modalReport')
                this.pickedReason = ''
            })
    }

    commentInfo(event) {
        this.$api.deleteComment(event.params.postId, event.params.commentId)
            .then((res: AxiosResponse) => {

            })
            .catch((err: AxiosError) => {

            })
    }

    reMount() {
        this.initData();
        this.fetch()
    }

}
